import { createApp } from 'vue'
import FormCheckbox from './FormCheckbox'

const el = '.kb-component--form-checkbox'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((FormCheckboxDOM) => {
            const props = {
                type: FormCheckboxDOM.dataset.type,
                tooltipText: FormCheckboxDOM.dataset.tooltiptext,
                errorMessageLabel: FormCheckboxDOM.dataset.errormessagelabel,
                helpMessageLabel: FormCheckboxDOM.dataset.helpmessagelabel,
                placeholder: FormCheckboxDOM.dataset.placeholder,
                label: FormCheckboxDOM.dataset.label,
                isRequired: !!(FormCheckboxDOM.dataset.isrequired === 'true'),
                fieldName: FormCheckboxDOM.dataset.fieldname
            }
            const component = createApp(FormCheckbox, props).use(Store)
            component.mount(FormCheckboxDOM)
        })
    }
}
